document.addEventListener('DOMContentLoaded', function() {
  
    // Select all product grid items
    const productGridItems = document.querySelectorAll('.product-grid-item');

    productGridItems.forEach(item => {
        // Select quantity adjuster buttons and the quantity field
        const minusButton = item.querySelector('.bulk-qty-remove');
        const plusButton = item.querySelector('.bulk-qty-add');
        const quantityField = item.querySelector('.txt-qty');

        // Event listener for minus button
        minusButton.addEventListener('click', () => {
            let quantity = parseInt(quantityField.value, 10);
            quantity = Math.max(quantity - 1, 1); // Ensure quantity never goes below 1
            quantityField.value = quantity;
        });

        // Event listener for plus button
        plusButton.addEventListener('click', () => {
            let quantity = parseInt(quantityField.value, 10);
            quantityField.value = quantity + 1;
        });

        // Add to Cart button event
        const addToCartContainer = item.querySelector('.product-grid-item-add-to-cart .add-to-cart');
      
        const addToCartButton = item.querySelector('.product-grid-item-add-to-cart .btn');
        addToCartButton.addEventListener('click', (event) => {
            event.preventDefault();

            const productId = item.querySelector('input[name="id"]').value;
            const quantity = parseInt(quantityField.value, 10);

            // Disable the button and show the spinner
            addToCartButton.disabled = true;
            addToCartContainer.classList.add('loading');
            

            // Update Shopify cart
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: productId,
                        quantity: quantity
                    }]
                })
            })
            .then(response => response.json())
            .then(data => {
                // Product added to cart successfully
                console.log(data);
                setTimeout(() => {

                  // Update cart count in class .cart-count-badge

                  // Revert the button to its original state
                  addToCartContainer.classList.remove('loading');
                  
                  // Show toast
                  Toastify({
                    text: data.items[0].product_title + " added to cart successfully.",
                    gravity: "top",
                    position: 'center',
                    style: {
                      background: '#1A3864',
                      boxShadow: '0 2px 10px 1px #dfdfdf'
                    },
                    onClick: function() {
                      location.href = window.Shopify.routes.root + 'cart'
                    }
                  }).showToast();
  
                  // Reset text field
                  quantityField.value = 1;
                  
                  addToCartButton.disabled = false;

                  fetch(window.Shopify.routes.root + 'cart.js', {
                      method: 'GET',
                      headers: {
                          'Content-Type': 'application/json'
                      }
                  })
                  .then(response => response.json())
                  .then(data => {
                    const itemCount = data.item_count;
                    const cartCountBadge = document.querySelector('.cart-count-badge');
                    if (itemCount === 0) {
                      cartCountBadge.textContent = "(0)";
                      cartCountBadge && cartCountBadge.classList.add('hidden');
                    } else {
                      if (cartCountBadge && cartCountBadge.classList.contains('hidden')) {
                          cartCountBadge.textContent = "("+itemCount+")";
                          cartCountBadge && cartCountBadge.classList.remove('hidden');
                      } else {
                          cartCountBadge.textContent = "("+itemCount+")";
                      }
                    }
                  });
                
                  
                }, 1000);
                
            })
            .catch((error) => {
                
                console.error('Error:', error);

                // Show toast
                  Toastify({
                    text: "An error was encountered. " + error.description,
                    gravity: "top",
                    position: 'center',
                    style: {
                      background: 'red',
                      boxShadow: '0 2px 10px 1px #dfdfdf'
                    },
                    onClick: function() {
                      location.href = window.Shopify.routes.root + 'cart'
                    }
                  }).showToast();
              
                // Handle the error and revert the button to its original state
                addToCartButton.disabled = false;
                addToCartContainer.classList.remove('loading');
            });
        });
    });
});
